import React, { FC } from 'react';

import { t } from 'state/intl/translations';
import { getDesignToken } from 'styles/constants';

import { MethodType } from './styled';

interface ICashAppMethod {
  isDisabled?: boolean;
  isRedesign?: boolean;
}

const CashAppMethod: FC<ICashAppMethod> = ({ isDisabled, isRedesign }) => {
  const textProps = isRedesign
    ? { variant: 'headerTwo', fontSize: 'lg', marginTop: '$2' }
    : undefined;

  return (
    <MethodType
      color={isDisabled ? getDesignToken('text-disabled') : getDesignToken('text-default')}
      {...textProps}
    >
      {t('cashAppPay')}
    </MethodType>
  );
};

export default CashAppMethod;
